import { Space, TextLoader } from '@procurify/ui'

export const FinancialAccountSummaryLoader = () => {
  return (
    <Space direction='horizontal' align='center' justify='space-between'>
      <Space direction='horizontal' size='xlarge'>
        <Space direction='horizontal' align='center'>
          <TextLoader height={32} width={48} />

          <Space size='small'>
            <TextLoader width={100} />
            <TextLoader width={120} height={24} />
          </Space>
        </Space>

        <Space.Divider />

        <Space size='small'>
          <TextLoader width={100} />
          <TextLoader width={120} height={24} />
        </Space>

        <Space.Divider />

        <Space size='small'>
          <TextLoader width={100} />
          <TextLoader width={120} height={24} />
        </Space>
      </Space>
    </Space>
  )
}
